import styles from './equals.module.scss';

interface EqualsProps {
  operandOne: React.ReactNode;
  operandTwo: React.ReactNode;
}

export const Equals = ({ operandOne, operandTwo }: EqualsProps) => {
  return (
    <div className={styles.equals}>
      <div className={styles.operand}>{operandOne}</div>
      <div className={styles.operator}>=</div>
      <div className={styles.operand}>{operandTwo}</div>
    </div>
  );
};
